import styled, { css } from 'styled-components'

import { Button as ButtonBase, ButtonColorStyleType } from '@icontainers/design-system/dist/molecules/Button'
import { ThemeModeType } from '@src/Application/Types/ComponentTypes'

export const StyledButton = styled(ButtonBase)<{ colorStyle: ButtonColorStyleType; $mode?: ThemeModeType }>`
    ${(props) =>
        props.colorStyle === 'primary' &&
        props.$mode === 'Dark' &&
        css`
            button {
                border: 2px solid ${props.theme.color.p500};
                padding: 10px 16px;

                &:hover {
                    border-color: ${props.theme.color.white};
                }
            }
        `};

    ${(props) =>
        props.colorStyle === 'secondary' &&
        props.$mode === 'Dark' &&
        css`
            button {
                &:hover {
                    border-color: ${props.theme.color.white};
                }
            }
        `};

    ${(props) =>
        props.colorStyle === 'ghost' &&
        props.$mode === 'Dark' &&
        css`
            button {
                &:hover {
                    color: ${props.theme.color.white};
                }
            }
        `};
`
